export interface FormQuestion {
  name:
    | "growingSeason"
    | "productId"
    | "cultivarName"
    | "plantingDate"
    | "harvestDate"
    | "irrigationSystemId"
    | "usedSeedAmount"
    | "density"
    | "description"
    | "treesAge"
    | "startBarePeriodDate"
    | "endBarePeriodDate"
    | "";
  placeholder: string;
  title: string;
  type: "farm" | "orchard" | "bare";
  kind: "inputText" | "inputNumber" | "select" | "datePicker";
  require: boolean;
  rule?: [
    {
      required: boolean;
      message: string;
    }
  ];
}

export const farmQuestions: FormQuestion[] = [
  {
    name: "growingSeason",
    placeholder: "انتخاب تاریخ",
    title: "فصل رشد (سال)",
    type: "farm",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "productId",
    placeholder: "",
    title: "نوع محصول",
    type: "farm",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "cultivarName",
    placeholder: "نام  رقم را تعیین کنید",
    title: "نام رقم",
    type: "farm",
    kind: "inputText",
    require: false,
  },
  {
    name: "plantingDate",
    placeholder: "تاریخ کاشت",
    title: "تاریخ کاشت",
    type: "farm",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "harvestDate",
    placeholder: "تاریخ برداشت",
    title: "تاریخ برداشت",
    type: "farm",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "irrigationSystemId",
    placeholder: "انتخاب کنید",
    title: "سیستم آبیاری",
    type: "farm",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "usedSeedAmount",
    placeholder: "میزان بذر مصرفی را تعیین کنید",
    title: "میزان بذر مصرفی (کیلوگرم در هکتار)",
    type: "farm",
    kind: "inputNumber",
    require: false,
  },
  {
    name: "density",
    placeholder: "تراکم را تعیین کنید",
    title: "تراکم",
    type: "farm",
    kind: "inputNumber",
    require: false,
  },
  {
    name: "description",
    placeholder: "توضیحات بیشتر",
    title: "توضیحات",
    type: "farm",
    kind: "inputText",
    require: false,
  },
];

export const orchardQuestions: FormQuestion[] = [
  {
    name: "growingSeason",
    placeholder: "انتخاب تاریخ",
    title: "فصل رشد (سال)",
    type: "orchard",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "productId",
    placeholder: "",
    title: "نوع محصول",
    type: "orchard",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "cultivarName",
    placeholder: "نام  رقم را تعیین کنید",
    title: "نام رقم",
    type: "orchard",
    kind: "inputText",
    require: false,
  },
  {
    name: "plantingDate",
    placeholder: "تاریخ کاشت",
    title: "تاریخ کاشت",
    type: "farm",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "harvestDate",
    placeholder: "تاریخ برداشت",
    title: "تاریخ برداشت",
    type: "orchard",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "irrigationSystemId",
    placeholder: "انتخاب کنید",
    title: "سیستم آبیاری",
    type: "orchard",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "density",
    placeholder: "تراکم را تعیین کنید",
    title: "تراکم",
    type: "orchard",
    kind: "inputNumber",
    require: false,
  },
  {
    name: "description",
    placeholder: "توضیحات بیشتر",
    title: "توضیحات",
    type: "orchard",
    kind: "inputText",
    require: false,
  },
];

export const bareQuestions: FormQuestion[] = [
  {
    name: "growingSeason",
    placeholder: "",
    title: "فصل رشد (سال)",
    type: "farm",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "productId",
    placeholder: "",
    title: "نوع محصول",
    type: "farm",
    kind: "select",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "startBarePeriodDate",
    placeholder: "شروع دوره آیش",
    title: "شروع دوره آیش",
    type: "farm",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "endBarePeriodDate",
    placeholder: "پایان دوره آیش",
    title: "پایان دوره آیش",
    type: "farm",
    kind: "datePicker",
    require: true,
    rule: [
      {
        required: true,
        message: "پر کردن این قسمت الزامی می باشد",
      },
    ],
  },
  {
    name: "description",
    placeholder: "",
    title: "توضیحات",
    type: "farm",
    kind: "inputText",
    require: true,
  },
];
